import { getEnumValue } from "@racoon/lib";

type EnumSchemaLike = { values: readonly { number: number; name: string }[] };

export const enumName = <T extends number>(schema: EnumSchemaLike, value: T) =>
  schema.values.find((v) => v.number === value)?.name;

// enumNumber tolerates both enum representations: gRPC numeric values and the
// string names some adapters resolve them to (the job map runs jobs through
// resolveJobEnums, so its rawJob carries string enums — comparing those
// against numeric constants silently fell into the default icon).
export const enumNumber = (
  schema: EnumSchemaLike,
  value: number | string | undefined,
): number | undefined => (typeof value === "string" ? getEnumValue(schema, value) : value);
